<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="25">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch"
                    :colSpan="4" />
                </Col>
            </Row>
        </transition>

        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="25">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">意向单管理</span>
						<span style="margin-left:20px;">会员类别:</span>
						<RadioGroup v-model="userType"
						    style="margin-left:4px;"
						    @on-change="onUserTypeChage">
						    <Radio label="F"> <span>外部会员</span></Radio>
						    <Radio label="E"> <span>内部会员</span></Radio>
						</RadioGroup>
                    </div>
                    <div class="right-bar">
                        <!-- <Button type="info"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            :loading="btnLoading"
                            @click="onExport()">导出</Button> -->

                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="25">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :extHeight="60"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <AddOrUpdate ref="addOrUpdateRef"  @getList-event="getMainTableRecords"/>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import AddOrUpdate from './add-or-update';
import { exportPreSaleOrderList } from '@/api/modules/preSale-management/preSale-order';
import { getIntentionBillOrderList, cancelDepositBillByUuid } from '@/api/modules/preSale-management/deposit-order';
import { getNoPaidDepositStatusOptions } from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import { numberToFixed } from '@/components/number-input/display-format';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
import { SignContractForUser } from '@/api/modules/system-management/user-management';

export default {
    name: 'IntentionOrderList',
    components: {
        StandPaginationTable,
        SearchCard,
        AddOrUpdate
    },
    data() {
        return {
            userType:'F',
            btnLoading: false,
            mainTable: {
                tableColumns: [
                    { title: '意向单编号', key: 'intentionBillRecordCode', align: 'center', excel: true },
                    { title: '关联销售单编号', key: 'intentionBillRecordRelatepreSaleOrderRecordCode', align: 'center', excel: true },
                    { title: '会员名称', key: 'userName', align: 'center', excel: true },
                    { title: '会员账号', key: 'userZhName', align: 'center', excel: true },
                    { title: '会员电话', key: 'userPhone', align: 'center', excel: true },
                    { title: '客户经理', key: 'customerManagername', align: 'center', excel: true },
                    { title: '定单合计', key: 'intentionBillRecordTotalProductCost', align: 'center', excel: true,
                        render: (h, params) => {   
                            return h('div', parseFloat(params.row.intentionBillRecordTotalProductCost.toFixed(2)));
                          
                        }
                    },
                    { title: '佣金比例(%)', key: 'intentionBillDetailSalesAssociateCommissionPercent', align: 'center', excel: true },
                    { title: '应付定金', key: 'intentionBillRecordDepositDue', align: 'center', excel: true },
                    { title: '定金单状态', key: 'intentionBillRecordOrderStatus', align: 'center', excel: true },                 
                    { title: '定单周期', key: 'weekDesc', align: 'center', excel: true,   
                        render: (h, params) => {  
                            if(params.row.intentionBillRecordCode) {
                                return h('div', `${params.row.weekKnownText} (${params.row.weekBeginDate} ~ ${params.row.weekEndDate})`);
                            }
                          
                        }
                    },
                    { title: '发货日期', key: 'intentionBillRecordSendProductDate', sortable: true, excel: true, align: 'center', render: (h, params) => dateRender(h, params.row.intentionBillRecordSendProductDate) },
                    { title: '下单时间', key: 'intentionBillRecordCreateAt', sortable: true, align: 'center', excel: true, render: (h, params) => dateTimeRender(h, params.row.intentionBillRecordCreateAt) },
                    { title: '客户备注', key: 'customerMsg', align: 'center', excel: true },
                    { title: '定单备注', key: 'orderRemark', align: 'center', excel: true },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                            visibility: params.row.customerManagername=='合计'? 'hidden' : 'visible'
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.addOrUpdateRef.showModal(params.row);
                                            }
                                        }
                                    }, '查看'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                            display: (
                                                this.$checkAccessArray(['B', 'C', 'S']) && !params.row.intentionBillRecordOrderStatus == '取消' ? 'inline' : 'none')
                                        },
                                        on: {
                                            click: () => {
                                                this.cancalOrder(params.row.intentionBillRecordUuid);
                                            }
                                        }
                                    }, '取消')
                                ]);
                            }
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: true,
                searchForm: [
                    { label: '意向单编号', type: 'Input', value: '', name: 'intentionBillRecordCode', sql: 'like' },
                    { label: '销售单编号', type: 'Input', value: '', name: 'intentionBillRecordRelatepreSaleOrderRecordCode', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(ues.userPersonName,ues.userName,ues.userPhone)', sql: 'like' },
                    { label: '下单时间', type: 'Daterange', value: '', name: 'intentionBillRecordCreateAt', sql: 'dateBetween' },
                    { label: '发货日期', type: 'Daterange', value: '', name: 'intentionBillRecordSendProductDate', sql: 'dateBetween' },
                    // {
                    //     label: '待支付定单状态',
                    //     type: 'Select',
                    //     value: [],
                    //     name: 'intentionBillRecordOrderStatus',
                    //     sql: 'in',
                    //     options: getNoPaidDepositStatusOptions()
                    // },
                    { label: '订单周次', type: 'Input', value: '', name: 'intentionBillDetailWeekKnownText', sql: 'like' }
                ]
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        cancalOrder(recordUuid){
        	this.$Modal.confirm({
        		  title: "是否确认取消该待支付订单？",
        		  content: "",
        		  onOk: async () => {
        			  this.mainTable.loading = true;
        			  cancelDepositBillByUuid({ intentionBillRecordUuid:recordUuid }).then(res => {
        				  this.mainTable.loading = false;
        				  if (res.code === 0) {
        					  this.getMainTableRecords();
        					  this.$Message.success('成功取消该待支付订单！');
        				  }
                        else{
                            this.$Message.error(res.message);
                        }
        			  });
        		  }
        	});
        },
        onExport() {
            this.mainTable.tableLoading = true;
            this.btnLoading = true;
            getIntentionBillOrderList(this.mainTable.tableSearch).then(res => {
                this.btnLoading = false;
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                    }
                }
            });
        },
        onUserTypeChage(){
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            getIntentionBillOrderList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.intentionBillMainVOList;
                    let intentionBillRecordTotalOrderCostTotal = 0;
                    let intentionBillRecordDepositDueTotal = 0;
                     
                    if (this.mainTable.tableData.length > 0) {
                        this.mainTable.tableData.forEach(e => {
                            intentionBillRecordTotalOrderCostTotal += e.intentionBillRecordTotalProductCost;
                            intentionBillRecordDepositDueTotal += e.intentionBillRecordDepositDue;
                        });
                        this.mainTable.tableData.push({
                            customerManagername: '合计',
                            intentionBillRecordTotalProductCost: numberToFixed(intentionBillRecordTotalOrderCostTotal, 2),
                            intentionBillRecordDepositDue: numberToFixed(intentionBillRecordDepositDueTotal, 2),
                            action: 1
                        });
                    }          
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
